export const CONTACT = {
  email: 'kkhammoud@gmail.com',
  github: 'https://github.com/KhadijaHammoud',
  linkedin: 'https://linkedin.com/in/khadijahammoud',
};
